import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "itira-steps-bottom d-block d-sm-none justify-content-center"
};
import Banner from '@/components/header/banner.vue';
import Patners from '@/components/header/patners.vue';
import Rating from '@/components/header/rating.vue';
import Feedback from '@/components/header/feedbackUpdate.vue';
import InlineCard from '@/components/header/inlineCard.vue';
import TravalerInsureCard from '@/components/header/travalerInsureCard.vue';
import Millionstraveler from '@/components/header/millionstraveler.vue';
import Help from '@/components/header/help.vue';
import stepsForHowG1GWorks from "@/components/visitor/stepsForHowG1GWorks.vue";
import videoContent from "@/components/header/videoContent.vue";
import g1gAdvantage from "@/components/header/g1gAdvantage.vue";
import g1gCovers from "@/components/header/g1gCovers.vue";
import { track } from "@/analytics/events";
import { computed, onMounted, onUnmounted, ref, toRaw, watch } from "vue";
import StepsForHowG1GWorksForHomePage from "@/components/header/stepsForHowG1GWorksForHomePage.vue";
import { itiraStates } from "@/composable/vuelidate";
import { useRouter } from "vue-router";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { uuid } from "vue-uuid";
import Bugsnag from "@bugsnag/js";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      useState,
      useActions
    } = createNamespacedHelpers("itira");
    const userActions = createNamespacedHelpers("user");
    const plansStore = createNamespacedHelpers("plans");
    const {
      resetItiraStore,
      getItiraSportsAdventure
    } = useActions(["resetItiraStore", "getItiraSportsAdventure"]);
    const {
      itira
    } = useState(["itira"]);
    const {
      deleteAllCartItems
    } = plansStore.useActions(["deleteAllCartItems"]);
    const {
      clearErrorMessage
    } = userActions.useActions(["clearErrorMessage"]);
    getItiraSportsAdventure();
    clearErrorMessage(null);
    const scrollToShowBottom = ref(false);
    const checkScrollPosition = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // Check if the bottom of the viewport is at position 420px
      scrollToShowBottom.value = scrollTop >= 420;
    };
    onMounted(() => {
      window.addEventListener('scroll', checkScrollPosition);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', checkScrollPosition);
    });

    //console.log(lastScrollTop,y,'lastScrollTop')
    const userStore = createNamespacedHelpers("user");
    const {
      getCustomerInfo
    } = userStore.useGetters(["getCustomerInfo"]);
    const trackPayload = {
      customer_info: toRaw(getCustomerInfo.value),
      cart_id: itira.value?.itira_uuid ?? null,
      event_id: uuid.v4(),
      event_name: "Itira Welcome"
    };
    const toIteraTravelReasons = () => {
      let {
        itira_uuid
      } = toRaw(itira.value);
      deleteAllCartItems(itira_uuid);
      itiraStates.value = [];
      resetItiraStore();
      track("ITIRA - Start", {
        ...trackPayload
      });
      Bugsnag.leaveBreadcrumb('Button clicked');
      setTimeout(() => {
        router.push({
          path: "/itira/travel-reasons"
        });
      }, 500);
      track(`Static Clickable`, {
        source: "Home page - Welcome ITIRA"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(Banner), _createVNode(Patners), _createVNode(Rating), _createVNode(Feedback), _createVNode(g1gCovers), _createVNode(StepsForHowG1GWorksForHomePage), _createVNode(g1gAdvantage), _createVNode(InlineCard), _createVNode(TravalerInsureCard), _createVNode(Millionstraveler), _createVNode(Help), scrollToShowBottom.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        class: "btn btn-primary btn-itira-steps-next",
        onClick: toIteraTravelReasons
      }, " Check prices ")])) : _createCommentVNode("", true)], 64);
    };
  }
};